import gql from 'graphql-tag';
import { VariantFragments } from './variant';

export namespace CitizenshipFragments {
  export const Citizenship = gql`
    fragment Citizenship on Citizenship {
      id
      title
      description
      imageUrls
      yearlyPrice
      monthlyPrice
      variant {
        ...Variant
      }
    }
    ${VariantFragments.Variant}
  `;
}
